/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Center_RightInputs */

const en_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center Right`)
};

const fr_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre Droite`)
};

const de_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte rechts`)
};

const it_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro destra`)
};

const ru_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центристский правый`)
};

const es_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro derecha`)
};

const zh_cn2_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中右`)
};

const ja_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央右`)
};

const hi_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र दाएँ`)
};

const pt_pt2_input_position_center_right = /** @type {(inputs: Input_Position_Center_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro-direita`)
};

/**
* | output |
* | --- |
* | "Center Right" |
*
* @param {Input_Position_Center_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_center_right = /** @type {((inputs?: Input_Position_Center_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Center_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_center_right(inputs)
	if (locale === "de") return de_input_position_center_right(inputs)
	if (locale === "it") return it_input_position_center_right(inputs)
	if (locale === "ru") return ru_input_position_center_right(inputs)
	if (locale === "es") return es_input_position_center_right(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_center_right(inputs)
	if (locale === "ja") return ja_input_position_center_right(inputs)
	if (locale === "hi") return hi_input_position_center_right(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_center_right(inputs)
	return en_input_position_center_right(inputs)
});